
// React Imports
import * as React from "react";
import {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import {
    DataGrid,
} from '@mui/x-data-grid';
import Box from "@mui/material/Box";

// App Imports

import {
    deleteUsers,  getUsersGridData
} from "./UsersClient";

import {changeUsers} from "./usersSlice";
import {changeCrudSnackbar} from "../CommonComponents/crudSnackbarSlice";
import UsersDrawer from "./UsersDrawer";
import CustomFooter from "../CommonComponents/GridCustomFooter";
import CrudSnackbar from "../CommonComponents/CrudSnackbar";
import { UsersGridColumns} from "./UsersGridColumns";
import AddFiltersExportToolbar from "../CommonComponents/AddFiltersExportToolbar";
import {changeDataPointAttribute} from "../DataPointAttribute/dataPointAttributeSlice";
import NotesDrawer from "../CommonComponents/NotesDrawer";

// main function
export default function UsersGrid() {


    // ****************** BEGIN STATES ****************************

    const [users, setUsers] = useState([]);
    const [gridVisible, setGridVisible] = React.useState(true);

    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************

    const selectorUsersId = useSelector((state) => state.usersSlc.value.id);
    const selectorDrawerState = useSelector((state) => state.usersSlc.value.usersDrawerState);
    const selectorUsersGridRefresh = useSelector((state) => state.usersSlc.value.usersGridRefresh);
    const hideActions = localStorage.getItem('hideActions') === "true";
    const dispatchData = useDispatch();

    // ********************** END STORE ********************************


    // ****************** BEGIN FETCH ****************************

    const fetchUsers = React.useCallback(() => {
        {
            if (hideActions === false) {
                return getUsersGridData()

                    .then(data => {
                        console.log(data);
                        setUsers(data);
                    })
            }
        }
    },[]);

    useEffect(() => {
        fetchUsers();
    }, [fetchUsers]);

    useEffect(() => {
        if (!selectorUsersGridRefresh) return;

        fetchUsers().finally(() => {
            dispatchData(changeUsers({
                selectorUsersGridRefresh: false
            }));
        });
    }, [selectorUsersGridRefresh, fetchUsers, dispatchData]);



    // ****************** END FETCH ****************************

    //
    // useEffect(() => {
    //     fetchUsers();
    //     dispatchData(changeUsers({usersGridRefresh: false}));
    // }, [useSelector((state) => state.usersSlc.value.usersGridRefresh)===true]);


    // ****************** BEGIN CRUD ***********************************

    const handleAdd = () => {
        dispatchData(changeUsers({id: null, firstName: null, lastName: null,
            department: null, role: null, status: null, approvalLimit: null, userName: null,
            createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
            usersDrawerState: true,  usersDrawerMode: "Add"}));
    };

    const removeUsers = () => {
        deleteUsers(selectorUsersId).then(() => {
            dispatchData(changeUsers({usersGridRefresh: true}));
            dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record deleted"}));
        })
    }

    // ****************** END CRUD ***********************************


    const handleClickedRow = (users) => {
        console.log('Users data from clicked row');
        console.log(users);
        dispatchData(changeUsers({id: users.id, firstName: users.firstName,
            lastName: users.lastName, department: users.department,
            role: users.role, status: users.status, rights: users.rights,
            approvalLimit: users.approvalLimit, userName: users.userName,
            password: users.password,
            createdOn: users.createdOn,createdBy:users.createdBy,
            lastModifiedOn:users.lastModifiedOn,lastModifiedBy:users.lastModifiedBy}));
    };

    // ****************** BEGIN RETURN ****************************

    return (
        <div style={{ height:800 , width: '100%' }}>
            <Box sx={{height: 70, pt: 1, pl: 3}}>
                <h3>Users</h3>
            </Box>
            {selectorDrawerState && <UsersDrawer
            />}
            {/*}*/}
            {gridVisible && <DataGrid
                experimentalFeatures={{ newEditingApi: true }}
                initialState={{
                }}
                aria-label={"Users"}
                rows={users}
                disableDensitySelector={true}
                disableColumnSelector={true}
                // columns={columns(fetchUsers)}
                columns={UsersGridColumns({
                    hideActions,
                    onEdit: () => dispatchData(changeUsers({ usersDrawerState: true, usersDrawerMode: "Edit" })),
                    onClone: () => dispatchData(changeUsers({ usersDrawerState: true, usersDrawerMode: "Clone" })),
                    onDelete: removeUsers
                })}
                onRowClick = {(users)=>handleClickedRow(users.row)}
                density={"compact"}
                pageSize={20}
                rowsPerPageOptions={[20]}
                rowKey={users => users.id}
                components={{
                    Toolbar: AddFiltersExportToolbar,
                    Footer: CustomFooter,
                }}
                componentsProps={{
                    toolbar: {
                        handleAdd: handleAdd
                    }
                }}

            />}
            <NotesDrawer/>
            <CrudSnackbar/>
        </div>

    );

    // ****************** END RETURN ****************************

}
